import type { SupportTicketStatus } from '@bliks-io/contracts';

/** Done with, either way: answered and closed, or merged into another request. */
export function isTicketClosed(status: SupportTicketStatus): boolean {
  return status === 'resolved' || status === 'merged';
}

/** Only a closed ticket opens again; a merged one carries on in its target. */
export function canReopenTicket(status: SupportTicketStatus): boolean {
  return status === 'resolved';
}

export function getTicketStatusBadgeVariant(status: SupportTicketStatus) {
  if (status === 'received') return 'default' as const;
  if (status === 'resolved' || status === 'merged') return 'secondary' as const;
  return 'outline' as const;
}
